// `/app/developers/docs` virou `/app/developers?tab=docs` (WEB-121): a tela morou aqui
// desde a WEB-118, agora é uma aba de "Webhooks e API". Rota mantida só como redirect.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/developers/docs/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/developers', search: { tab: 'docs' } });
  },
});
